<script setup lang="ts">
import { RouterView } from 'vue-router';
import AppShell from './components/AppShell.vue';
</script>

<template>
  <AppShell>
    <RouterView />
  </AppShell>
</template>
